import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDesktop } from "@fortawesome/free-solid-svg-icons";
import { faCode } from "@fortawesome/free-solid-svg-icons";
import { faMagic } from "@fortawesome/free-solid-svg-icons";
import { faUserSecret } from "@fortawesome/free-solid-svg-icons";

const Services = () => {
  return (
    <div className="services" id="services">
      <div className="container text-center">
        <h1 className="title text-dark">My Services</h1>
        <div className="grid">
          <div className="g-col-sm-3 card">
            <ul className="list-unstyled text-center">
              <li>
                <FontAwesomeIcon
                  icon={faDesktop}
                  style={{
                    fontSize: "40px",
                    color: "#f9ab00",
                  }}
                />
              </li>
              <h3>Web Design</h3>
              <p className="lead">
                I Can Design Static and Dynamic Websites Using Technolgies and
                Libraries to Make the Site Interact with The Users.
              </p>
            </ul>
          </div>
          <div className="g-col-sm-3 card">
            <ul className="list-unstyled text-center">
              <li>
                <FontAwesomeIcon
                  icon={faCode}
                  style={{ fontSize: "40px", color: "#f9ab00" }}
                />
              </li>
              <h3>Web Development</h3>
              <p className="lead">
                I Can Deal With The Servers And Databases Like MySql And Using
                Frameworks Like Laravel.
              </p>
            </ul>
          </div>
          <div className="g-col-sm-3 card">
            <ul className="list-unstyled text-center">
              <li>
                <FontAwesomeIcon
                  icon={faMagic}
                  style={{ fontSize: "40px", color: "#f9ab00" }}
                />
              </li>
              <h3>Responsive</h3>
              <p className="lead">
                I Can Deal With Media Queries and Css Frameworks Like Bootstrap
                to Make the Site Work on all Different Devices Like Mobiles,
                Tablets...
              </p>
            </ul>
          </div>
          <div className="g-col-sm-3 card">
            <ul className="list-unstyled text-center">
              <li>
                <FontAwesomeIcon
                  icon={faUserSecret}
                  style={{ fontSize: "40px", color: "#f9ab00" }}
                />
              </li>
              <h3>Cyber Security</h3>
              <p className="lead">
                I Can Deal With Neworks And Defferent OS Like Ubuntu, MacOs,
                Kali-Linux And Bug Hunter.
              </p>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
